<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {

    };
  },
  methods: {
    // changeLanguage(lang) {
    //   this.$i18n.locale = lang;
    //   // 如果需要，可以在这里动态加载翻译文件
    //   // this.loadTranslations(lang);
    // },
  },
};
</script>

<style lang="scss">
html,
body {
  padding: 0;
  margin: 0;
  background-color: #f4f6f8;
}

div,
span,
p,
i,
a,
ul,
li,
input,
button,
textarea,
h1,
h2,
h3,
h4 {
  box-sizing: border-box;
}

.flexcenter {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
